/**
 * The five-bar mark and the fixed palette it is drawn in, shared by
 * `BrandWordmark` and the build's icon generator.
 *
 * @module brand/mark
 */

/** Fixed colours for surfaces outside the theme, such as browser tabs. */
export const ink = "#14232d";
export const paper = "#fbf6ea";
export const amber = "#e3a86a";

export const markViewBox = { width: 144, height: 152 } as const;
export const barWidth = 24;
export const barRadius = 12;

export interface Bar {
  x: number;
  y: number;
  height: number;
  accent?: boolean;
}

export const bars: readonly Bar[] = [
  { x: 0, y: 48, height: 104 },
  { x: 30, y: 24, height: 96 },
  { x: 60, y: 0, height: 152 },
  { x: 90, y: 32, height: 96 },
  { x: 120, y: 0, height: 104, accent: true },
];
